import { render, staticRenderFns } from "./WhatsappDistribution.vue?vue&type=template&id=f6549664&"
import script from "./WhatsappDistribution.vue?vue&type=script&lang=ts&"
export * from "./WhatsappDistribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports